import type { ReportInfo } from "../../../../api/types/svTypes.ts";
import { CustomToolbarActions } from "../../reporting/report-lists/reports/grid/CustomToolbarActions";

interface Props {
  selectedReports: ReportInfo[];
  copyReports?: (ids: string[]) => void;
  deleteReports: (ids: string[]) => void;
  hideCopy?: boolean;
}

const CustomHeader = ({ selectedReports, copyReports, deleteReports, hideCopy }: Props) => (
  <CustomToolbarActions
    selectedReports={selectedReports}
    onCopy={copyReports}
    onDelete={deleteReports}
    hideCopy={hideCopy}
  />
);

export default CustomHeader;
